import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';

export const StyledBlock = styled.div`
  width: ${scaleSize(1480)}px;
  font-family: Roboto, sans-serif;
  font-size: ${scaleSize(34)}px;
  line-height: 1.41;
  margin: ${scaleSize(40)}px auto;
  color: ${({ theme }) => theme.mainTextColor};
`;

export const StyledContent = styled.div`
  transform: translate3d(0, ${({ top }) => top || 0}px, 0);
  margin-bottom: ${scaleSize(94)}px;
`;

export const StyledHeader = styled.div`
  height: ${scaleSize(72)}px;
  font-size: ${scaleSize(48)}px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  color: ${({ theme }) => theme.defaultColor};
`;

const STATUS_BAR_HEIGHT = scaleSize(960);
const THUMBNAIL_HEIGHT = scaleSize(80);

export const StyledStatusBar = styled.div`
  position: absolute;
  top: ${scaleSize(60)}px;
  right: ${scaleSize(80)}px;
  width: ${scaleSize(8)}px;
  height: ${scaleSize(STATUS_BAR_HEIGHT)}px;
  border-radius: ${scaleSize(4)}px;
  background-color: ${({ theme }) => theme.submenuActiveColor};

  &:before {
    content: '';
    position: relative;
    top: ${({ topPercentsOffset }) => {
      let positon = 0;
      if (topPercentsOffset) {
        const offset = STATUS_BAR_HEIGHT * topPercentsOffset;
        positon = offset > THUMBNAIL_HEIGHT ? offset - THUMBNAIL_HEIGHT : 0;
      }
      return positon;
    }}px;
    display: block;
    border-radius: ${scaleSize(4)}px;
    width: ${scaleSize(8)}px;
    height: ${THUMBNAIL_HEIGHT}px;
    background: ${({ theme }) => theme.mainTextColor};
  }
`;
